import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux'
import { resetTitle } from '../../actions/titleActions';
import AdministratorHelp from './Administrators';
import TeacherHelp from './Teachers';
import AssistantHelp from './Assistants';
import UserHelp from './Users';
import GuestHelp from './Guests';

export default (): JSX.Element => {

  const dispatch = useDispatch();
  useEffect(() => {
    if (!dispatch) {
      return;
    }

    dispatch(resetTitle());
  }, [dispatch]);

  return (
    <div className="container">
    	<h1>Help and FAQ</h1>

      <details className="mb-3" open>
        <summary className="clickable" style={{ listStyle: 'none', display: 'block', padding: '8px 12px', fontWeight: 600, borderRadius: '4px', background: '#f0f0f0', border: '1px solid #ccc', marginBottom: '8px' }}>
          Video walkthrough — the queue in 2½ min
        </summary>
        <video controls preload="none" poster="/demo-walkthrough-poster.jpg"
          style={{ width: '100%', maxWidth: '1600px', display: 'block', borderRadius: '6px', background: '#000', border: '1px solid #ccc' }}>
          <source src="/demo-walkthrough.mp4" type="video/mp4" />
        </video>
        <p className="text-muted" style={{ fontSize: '0.9em', marginTop: '8px' }}>
          Silent walkthrough — on-screen captions explain each step.
        </p>
      </details>

      <AdministratorHelp />
      <TeacherHelp />
      <AssistantHelp />
      <UserHelp />
      <GuestHelp />

      <p><strong>To request a new queue:</strong> Contact{' '}
        <a href="mailto:viggo@kth.se">Viggo Kann</a>,{' '}
        <a href="mailto:lk@kth.se">Linda Kann</a>, or{' '}
        <a href="mailto:emmaen@kth.se">Emma Enström</a>.
      </p>
      <p><strong>Feature requests &amp; bugs:</strong> Contact <a href="mailto:alba@kth.se">alba@kth.se</a>.</p>
    </div>
)};
